<template>
  <div class="home-view-shell">
    <div class="w-view-shell">
      <div class="banner-user-shell">
        <div class="banner-shell">
          <swiper :options="options" class="swiper-box">
            <swiper-slide v-for="(item, index) in banner_list" :key="index">
              <a :href="item.jump_url">
                <img
                  :src="item.img_url"
                  :alt="item.banner_title"
                  :title="item.banner_title"
                />
              </a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="user-info-shell">
          <div class="login-shell" v-if="show">
            <div
              class="user-info"
              @click.stop="$router.push('/personal?code=6')"
            >
              <img :src="user_info.head_img_url" alt="" class="user-img" />
              <div class="user-name">{{ user_info.nick_name }}</div>
              <div class="user-account">{{ user_info.user_acc }}</div>
            </div>
            <div class="nav-list">
              <router-link
                class="nav-box"
                v-for="(item, index) in nav_list"
                :key="index"
                :to="item.path"
              >
                <div class="nav-name">{{ item.name }}</div>
                <img
                  :src="item.icon"
                  alt=""
                  class="nav-icon"
                  :style="'width: ' + item.width + 'px'"
                />
              </router-link>
            </div>
          </div>
          <div v-else class="login">
            <img class="img" src="@/assets/head.png" alt="" />
            <div class="go">您还没有登录</div>
            <button class="Btn pointer" @click="show_login_son()">
              登录
            </button>
            <!-- <button class="Btns pointer" @click="show_reg_son()">
              注册
            </button> -->
          </div>
        </div>
      </div>
      <!-- 通知 -->
      <div class="news-banner-sehll">
        <img src="@/assets/inform.png" alt="" />
        <div class="news-sehll">
          <swiper :options="options2" ref="mySwiper" class="swiper-box">
            <swiper-slide v-for="(item, index) in news_list" :key="index">
              <div style="display: flex;align-items: center;justify-content: space-between;">
                <router-link
                  class="span"
                  :to="'new-detail?news_id=' + item.news_id"
                  >{{ item.news_title }}</router-link
                >
                <span class="span2">{{ item.add_time }}</span>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="home-say-shell">
        <img class="img" src="@/assets/vodis.png" alt="" />
        <div class="say-name">继续教育</div>
        (交费、学习入口)
        <div class="download" @click="handleDownload">
          <img src="@/assets/guge.png" alt="">
          <span>请下载使用<span>谷歌浏览器</span>学习</span>
        </div>
      </div>
      <!-- 教育入口 -->
      <div class="continue pointer">
        <div class="right-in">
          <img src="@/assets/home_in2.png" alt="" @click="handleOpen(1)" />
        </div>
        <div class="left-in">
          <img src="@/assets/home_in1.png" alt="" @click="handleOpen(2)" />
          <span>(免费)</span>
          <!-- <a href="https://stu.chinahrt.com/index.html#/pharmacist/index">
                        <img src="@/assets/home_in1.png" alt="">
                    </a> -->
        </div>
      </div>
      <!-- 推荐课程 -->
      <recom-mend />
      <!-- 免费体验课程 -->
      <Free />
      <!-- 热门课程 || 食品安全课程 -->
      <recom-mends />
      <!-- 名师风采 -->
      <teac-her />
      <!-- 行业资讯 -->
      <infor-mation />
    </div>

    <el-dialog
      title="暂无权限"
      :visible.sync="visible"
      top="30vh"
      width="30%"
      center
    >
      <div
        style="font-size: 16px; text-align: center;width:300px;margin:0 auto 20px;color:red"
      >
        注：仅限在“湖南省药师教育管理平台”已报湘源学校继续教育的学员进入学习。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visible = false">知道了</el-button>
      </span>
    </el-dialog>

		<el-dialog
      :visible.sync="inform"
      top="10vh"
      width="40%"
			@close="onClose"
      center>
      <div class="inform">
				<h3>执业药师继续教育“学习与考核”操作须知</h3>
				<div class="hint">（专业+公需课一站完成，公需课免费，每天不限时学习！）</div>

				<div class="title">1.培训报名：</div>
				<p>在省药监局<span>“湖南省药师教育管理平台”</span>https://yaoshi.hnmpaed.com →首页<span>“药师登录”</span>(首次学习先点“药师注册”完成注册)→选择<span>“教育培训”</span>（需补学2019、2020年专业科目学分，请点“补学教育”）→选择培训方式<span>“远程”</span>→选择<span>“长沙市湘源医药食品职业培训学校”</span>。</p>

				<div class="title">2.学习登录：</div>
				<div class="list"><div>1</div>、电脑学习：跳转湘源教育网址<span>“https://xy.xyyysp.com”</span>首页→<span>登录</span>（用户：身份号证号，密码：默认身份证后六位）</div>
				<div class="list"><div>2</div>、手机APP学习：</div>
				<div class="qrcode">
					<img src="@/assets/loadApp.png" alt="">
				</div>
				<div class="way">
					<div>方法1、扫以上二码下载<span>“湘源教育”</span>官方APP</div>
					<div>方法2、在手机应用市场搜索<span>“湘源教育”</span>APP下载</div>
					<div>方法3、在微信搜索<span>“湘源教育”</span>公众号并关注，进入选择<span>“药师报名”</span>下载手机APP学习</div>
				</div>

				<div class="title">3.选课缴费：</div>
				<div class="list"><div>1</div>、电脑端：进学习网址<span>“https://xy.xyyysp.com”</span>首页→点<span>“专业科目”</span>选课、缴费（<span>公需科目免费</span>）</div>
				<div class="list"><div>2</div>、手机端：进<span>“湘源教育APP”</span>首页→点<span>“专业科目”</span>选课、缴费（<span>公需科目免费</span>）</div>
				<div class="min-title">选课说明：</div>
				<p>专业科目：所选课程<span>不少于60</span>学时，每学时的时长为40分钟，（8门必修课系统默认已选）其它自由选择课程，累计达到2400分钟即可，<span>计20学分</span>。</p>
				<p>公需科目：所选课程<span>不少于30</span>学时，每学时的时长为45分钟，自由选择课程，累计达到1350分钟即可，<span>计10学分</span>。</p>

				<div class="title">4.学习要求：</div>
				<p>按省药监局学习统一要求：</p>
				<p>专业科目：<span>人脸识别进入，学习过程抓拍，课程评价</span>。学习记录实时上传省局药师管理平台，等待审核（5个工作日内）。</p>
				<p>公需科目：<span>每天的第一次进入人脸识别，随堂考核，课程评价</span>。学完全部课程，在省局药师管理平台<span>自动生成学分卡</span>。</p>

				<div class="title">5.考核与学分授予：</div>
				<p>专业科目：省局学习档案审核通过后，进入<span>“湘源教育APP”</span>首页→点<span>“专业课程”</span>→点<span>“正式考核”</span>或微信搜索<span>“湖南省药师考核”</span>小程序，参加专业科目考核。考核合格的5个工作日后，登录管理平台自行查询专业科目学分。</p>
				<p><span>为您贴心服务，独家设立“随堂练习”模块，助您一次性通过考核获取学分。</span></p>
				<p>公需科目：在“湘源教育”平台<span>完成学习</span>和<span>随堂考核</span>，湖南省药师教育管理平台<span>自动生成</span>公需科目<span>学分卡</span>。</p>
				<div class="min-title">免学免考政策</div>
				<div class="list"><div>1</div>、<span>60周岁</span>以上药师只需参加培训学习，药师考核<span>免考</span>。</div>
				<div class="list"><div>2</div>、凡参加湘源学校“南开大学网络教育”和“中国药科大学函授教育”的药学学历在籍执业药师学员，<span>免参加“专业和公需科目”学习与考核</span>，获取省局药师管理平台“专业和公需科目”学分卡。</div>

				<div class="title">6.学分查询：</div>
				<p><span>专业科目、公需科目</span>学分卡：在<span>“湖南省药师教育管理平台”</span>https://yaoshi.hnmpaed.com 首页→点<span>“药师登录”</span>→点<span>“学分卡”</span>→选择“当前年份+类型（<span>专业课、公需课</span>）”→学分证明自行下载<span>保存或打印</span>，此学分全国范围内有效。</p>

				<div class="service">客服电话：400-811-5865转1</div>
      </div>
			<span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="inform = false">知道了</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="hintShow"
      top="30vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      @close="handleClose"
    >
      <div style="margin:0 auto 20px;" v-html="endHintInfo.alter_info"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">知道了</el-button>
      </span>
    </el-dialog>
    
    <el-dialog
      title=""
      :visible.sync="notice"
      top="30vh"
      width="30%"
      center
    >
      <header style="font-size: 20px;text-align: center;" slot="title">用户协议和隐私政策</header>
      <div
        style="font-size: 16px; width:400px;margin:0 auto 0px;line-height: 32px;text-indent: 30px;color: #000;"
      >
      请仔细阅读并充分知悉<span style="color: #2AA9B5;cursor: pointer;font-size: 18px;" @click="handlePrivacy(7)">《用户协议》</span>和<span style="color: #2AA9B5;cursor: pointer;font-size: 18px;" @click="handlePrivacy(9)">《隐私政策》</span>全部条款。为保障教学服务正常开展，平台会收集设备信息、手机号、身份证号等个人信息，详情可查阅两份协议。若认可全部内容，点击“同意”开始接受平台的服务。
      </div>
      <div slot="footer" class="notice-footer">
        <div @click="handleRefuse(1)">拒绝并离开</div>
        <span></span>
        <div style="color: #2AA9B5;" @click="handleConsent(1)">同意使用</div>
      </div>
    </el-dialog>
    
    <el-dialog
      title=""
      :visible.sync="noticeUpate"
      top="30vh"
      width="30%"
      center
    >
      <header style="font-size: 20px;text-align: center;" slot="title">隐私政策更新通知</header>
      <div
        style="font-size: 16px; width:400px;margin:0 auto 0px;line-height: 32px;text-indent: 30px;color: #000;"
      >
      我们已更新<span style="color: #2AA9B5;cursor: pointer;font-size: 18px;" @click="handlePrivacy(9)">《隐私政策》</span>，请您仔细阅读完整条款。请确认是否同意更新后的隐私政策及个人信息处理规则。
      </div>
      <div slot="footer" class="notice-footer">
        <div @click="handleRefuse(2)">不同意</div>
        <span></span>
        <div style="color: #2AA9B5;" @click="handleConsent(2)">同意并继续使用</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeadTou from "@/components/hard.vue";
import RecomMend from "./components/recommend.vue";
import Free from "./components/free.vue";
import RecomMends from "./components/recommends.vue";
import TeacHer from "./components/teacher.vue";
import InforMation from "./components/information.vue";
import NavigationButton from "@/components/navigationbutton.vue";
import VeriFication from "../../components/verification";

import { Toast } from 'vant'

export default {
  name: "home",
  components: {
    HeadTou,
    RecomMend,
    Free,
    RecomMends,
    TeacHer,
    InforMation,
    NavigationButton,
    VeriFication,
  },
  data() {
    return {
      show: false,
      visible: false,
      checked: true,
      // 用户信息
      user_info: {
        company_id: 0,
        company_name: "",
        head_img: "",
        head_img_url: "",
        nick_name: "",
        sex: 0,
        sex_text: "未知",
        user_acc: "",
        user_id: 0,
        user_num: "",
      },
      page: 1,
      // 轮播图
      banner_list: [],
      options: {
        // 轮播图配置
        autoplay: {
          delay: 3600,
        },
        loop: true,
        speed: 500,
        resistanceRatio: 0,
        // autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
      },
      nav_list: [
        {
          name: "培训课程",
          path: "/classify",
          icon: require("@/assets/book.png"),
          width: 36,
        },
        {
          name: "开始学习",
          path: "/personal",
          icon: require("@/assets/notebook.png"),
          width: 29,
        },
        {
          name: "帮助中心",
          path: "/help",
          icon: require("@/assets/help.png"),
          width: 35,
        },
        {
          name: "我的档案",
          path: "/personal?code=6",
          icon: require("@/assets/record.png"),
          width: 29,
        },
      ], // 课程分类
      // 通知
      options2: {
        // 轮播图配置
        direction: "vertical",
        autoplay: {
          delay: 3600,
        },
      },
      news_list: [],
			inform: false,
      hintShow: false,
      hintType: 1,
      endHintInfo: {},
      notice: false,
      noticeUpate: false,
      agreementV: ''
    };
  },
  created() {
    let notice = localStorage.getItem("notice") || false
    if (!notice) {
      this.$nextTick(() => {
        this.notice = true
      })
    }
		// this.inform = Number(sessionStorage.getItem("inform")) ? false : true
	},
  mounted() {
    window.scrollTo(0, 0);
    if (localStorage.getItem("token")) {
      this.getUserInfo();
      this.show = true;
      this.getHintStatus()
    }
    this.get_banner();
    this.get_news();
    this.getAgreementVison()
    this.$Bus.$on('loginOk', this.getHintStatus)
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    getAgreementVison () {
      this.API.post("Home/article_out-protocol_version", {}).then(res => {
        if (res.errno == 0) {
          const agreementV = uni.getStorageSync('agreementV') || ''
          this.agreementV = res.data
          if (agreementV && agreementV != res.data) {
            this.noticeUpate = true
          } else {
            uni.setStorageSync('agreementV', res.data)
          }
        }
      })
    },
    handleConsent (type) {
      if (type == 1) {
        this.notice = false
        localStorage.setItem("notice", true)
      } else {
        this.noticeUpate = false
        uni.setStorageSync('agreementV', this.agreementV) 
      }
    },
    handleRefuse (type) {
      if (type == 1) {
        this.notice = false
        window.location.href = 'about:blank';
      } else {
        this.noticeUpate = false
        window.location.href = 'about:blank';
      }
    },
    handlePrivacy (type) {
      this.$router.push({path: '/privacy?type=' + type})
    },
    getHintStatus () {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        this.endHintInfo = res.data
        // this.endHintInfo.alter_status = 1
        if (this.endHintInfo.alter_status == 1) {
          this.hintShow = true
        }
      })
    },
		onClose () {
			sessionStorage.setItem("inform", 1)
		},
    go_login() {
      let buy_phar = localStorage.getItem("buy_phar");
      if (localStorage.getItem("token")) {
        if (buy_phar == 1) {
          this.$router.push("/personal");
        } else {
          this.API.post("user/phar_in-buy_status", {}).then((res) => {
            console.log(res);
            if (res.errno == 0) {
              if (res.data.course_status) {
                this.$router.push({
                  path: "/personal",
                  query: { code: 10 },
                });
              } else {
                this.$router.push("/pharmacist-course");
              }
            } else {
              if (res.code == 2012) {
                this.visible = true;
              } else {
                this.API.SMessage(res.data.message);
              }
            }
          });
        }
      } else {
        this.$emit("on-login");
      }
    },
    show_login_son() {
      this.$emit("on-login");
    },
    show_reg_son() {
      this.$emit("on-reg");
    },
    get_news() {
      // 系统消息
      this.API.post("Home/article_out-get_news_list", {}).then((res) => {
        this.news_list = res.data.news_list;
      });
    },
    get_banner() {
      this.API.post("Home/article_out-get_banner", {
        banner_type: 0,
      }).then((res) => {
        this.banner_list = res.data.banner_list;
      });
    },
    // 获取用户信息
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        this.user_info = res.data.user_info;
        localStorage.setItem("user_id", this.user_info.user_id);
      });
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    handlePulic() {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        if (res.data.state == 1) {
          this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonText: '知道了',
          })
        } else {
          this.API.post("user/public_in-access_permissions", {}).then((result) => {
            if (result.errno == 0) {
              this.API.post("user/public_in-public_year", {}).then((res) => {
                if (res.errno == 0) {
                  if (res.data.year.length == 0) {
                    this.visible = true;
                    return;
                  }
                  if (res.data.buy_status) {
                    this.$router.push("/personal");
                  } else {
                    this.$router.push("/PublicBuy?year=" + res.data.year[0]);
                  }
                }
              });
            } else {
              this.visible = true;
            }
          });
        }
      })
    },
    handleOpen (type) {
      this.hintType = type
      // this.hintShow = true
      let token = localStorage.getItem('token')
      if (this.hintType == 1) {
        if (!token) {
          Toast({
            message:'登录失效/未登录,请先登录!',
            duration: 2000
          })
          return;
        }
        this.go_login()
      } else {
        this.handlePulic()
      }
    },
    handleClose () {
      this.hintShow = false
      // let token = localStorage.getItem('token')
      // if (this.hintType == 1) {
      //   if (!token) {
      //     Toast({
      //       message:'登录失效/未登录,请先登录!',
      //       duration: 2000
      //     })
      //     return;
      //   }
      //   this.go_login()
      // } else {
      //   this.handlePulic()
      // }
    },
    handleDownload () {
      window.open('https://www.google.cn/chrome/')
    }
  },
};
</script>

<style lang="less" scoped>
.home-say-shell {
  display: flex;
  align-items: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  color: #2AA9B5;
  margin-bottom: 20px;
  font-weight: bold;

  img {
    width: 59px;
    height: 54px;
  }

  .say-name {
    line-height: 59px;
    margin-left: 26px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-right: 20px;
  }
  .download {
    margin-left: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      margin-right: 10px;
    }
    span {
      font-size: 22px;
      font-weight: bold;
      color: #000000;
      span {
        color: red
      }
    }
  }
}

.home-view-shell {
  background-color: #fff;

  .w-view-shell {
    min-width: 1200px;
  }
}

.banner-user-shell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 1200px;
  margin: 0px auto;
  overflow: hidden;
  padding: 10px 0;

  .banner-shell {
    margin: 0;
    width: 942px;
    height: 450px;
    margin-right: 18px;
    background-size: 100% 100%;
    border-radius: 10px;
    padding: 0;

    .swiper-box {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;

      img {
        display: inline-block;
        border-radius: 18px;
        width: 100% !important;
        height: 100%;
        cursor: pointer;
      }
    }
  }

  .login-shell {
    width: 240px;
    min-width: 240px;
    height: 450px;
    background-color: #3a4459;
    border-radius: 10px;
    padding-top: 30px;

    .user-info {
      width: 100%;
      cursor: pointer;

      .user-img {
        display: block;
        width: 100px;
        height: 100px;
        margin: 0px auto 24px;
        border-radius: 50%;
      }

      .user-name {
        text-align: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }

      .user-account {
        text-align: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .nav-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 40px;

      .nav-box {
        width: 50%;
        margin-bottom: 15px;
        cursor: pointer;

        .nav-name {
          text-align: center;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        .nav-icon {
          display: block;
          width: 36px;
          margin: 10px auto;
        }
      }
    }
  }

  .login {
    width: 240px;
    height: 450px;
    background-color: #3a4459;
    border-radius: 10px;

    .img {
      width: 100px;
      height: 100px;
      margin: 65px 70px 22px 70px;
      border-radius: 50%;
    }

    .go {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
    }

    .go1 {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin-bottom: 40px;
    }

    .Btn {
      width: 160px;
      height: 50px;
      background: #ffffff;
      border-radius: 25px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #3a4459;
      border: 0;
      margin: 64px 33px 26px 47px;
      outline: none;
    }

    .Btns {
      width: 160px;
      height: 50px;
      border: 1px solid #ffffff;
      border-radius: 25px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      background-color: #3a4459;
      margin: 0 33px 26px 47px;
      outline: none;
    }

    .help {
      margin-bottom: 20px;

      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-left: 31px;
      }

      .img1 {
        width: 36px;
        height: 28px;
        margin-left: 50px;
      }

      .img2 {
        width: 29px;
        height: 30px;
        margin-left: 75px;
      }

      .img3 {
        width: 35px;
        height: 34px;
        margin-left: 51px;
      }

      .img4 {
        width: 29px;
        height: 30px;
        margin-left: 75px;
      }
    }
  }
}

.news-banner-sehll {
  width: 72%;
  min-width: 1200px;
  height: 90px;
  background: #ffffff;
  border: 1px dashed #d2d2d2;
  margin-bottom: 20px;

  .news-sehll {
    height: 100%;
    overflow: hidden;
    position: relative;

    .swiper-box {
      height: 100%;
      cursor: pointer;
    }
  }

  img {
    float: left;
    margin: 20px 20px 20px 29px;
    width: 80px;
    height: 50px;
  }

  span {
    line-height: 90px;
  }

  .span {
    display: flex;
    align-items: center;
    height: 90px;
    color: red;
    font-size: 26px;
  }

  .span2 {
    margin-right: 31px;
  }
}

.box {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .w {
    min-width: 1200px;
    margin: 0 auto;

    .continue {
      width: 1200px;
      height: 230px;
      margin-top: 37px;
    }
  }
}

/deep/ .el-dialog__body {
  padding-bottom: 0px;
}

i {
  .zhanghao {
    width: 24px;
    height: 32px;
    margin-right: 18px;
  }

  .mima {
    width: 26px;
    height: 30px;
    margin-right: 18px;
  }

  .shimingyanzheng {
    width: 33px;
    height: 26px;
    margin-right: 10px;
  }

  .yanzhengma {
    width: 30px;
    height: 30px;
    margin-right: 17px;
  }
}

.form {
  height: 230px;
}

.yanzhengma {
  width: 26px;
  height: 30px;
  margin-right: 17px;
}

.Btn111 {
  width: 100px;
  height: 30px;
  border: 0;
  border-radius: 10px;
}

.continue {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left-in,
  .right-in {
    width: 48%;
    position: relative;
    img {
      width: 100%;
    }
    span {
      position: absolute;
      top: 50%;
      left: calc(50% - 30px);
      transform: translate(-50%, -50%);
      color: red;
      font-size: 28px;
    }
  }
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  font-size: 28px;
}

.inform {
	color: #000000;
	font-size: 20px;
	height: 800px;
	overflow-y: auto;
	&::-webkit-scrollbar{
		width:12px;
		height:12px;
	}
	&::-webkit-scrollbar-track{
		background: rgb(239, 239, 239);
		border-radius:2px;
	}
	&::-webkit-scrollbar-thumb{
		background: #bfbfbf;
		border-radius:10px;
	}
	&::-webkit-scrollbar-thumb:hover{
		background: #888;
	}
	&::-webkit-scrollbar-corner{
		background: #179a16;
	}
	h3 {
		text-align: center;
		font-size: 30px;
		color: #000000;
		background-color: #2aa9b5;
		width: fit-content;
		margin: 0 auto;
	}
	.hint {
		text-align: center;
		color: red;
		font-size: 24px;
		margin: 10px 0;
	}
	.title {
		font-size: 24px;
		font-weight: bold;
		background-color: #2aa9b5;
		width: fit-content;
		margin: 10px 0;
	}
	p {
		text-indent: 40px;
		font-size: 20px;
		line-height: 40px;
	}
	span {
		color: red;
		font-size: 20px;
	}
	.list {
		font-size: 20px;
		line-height: 40px;
		text-indent: 40px;
		> div {
			text-indent: 0px;
			display: inline-block;
			width: 25px;
			height: 25px;
			line-height: 25px;
			border: 1px solid #000000;
			border-radius: 50%;
			text-align: center;
		}
	}
	.qrcode {
		margin: 15px auto;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 200px;
		}
	}
	.way {
		width: 70%;
		margin: 0 auto;
		div {
			font-size: 20px;
			text-indent: 40px;
			line-height: 40px;
		}
	}
	.min-title {
		font-size: 20px;
		text-indent: 40px;
		font-weight: bold;
		line-height: 40px;
	}
	.service {
		text-align: center;
		font-size: 26px;
		margin-top: 20px;
		padding-bottom: 20px;
	}
}

.notice-footer {
  border-top: 1px solid #5B5C5B;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 30px;
  height: 50px;
  > div {
    flex: 1;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
  }
  > span {
    width: 1px;
    height: 50px;
    background-color: #5B5C5B;
  }
}
</style>
